/* Tessera "complete the set" bundle builder.

   The set discount applies only when EVERY component quantity exactly matches
   the required composition from the spec sheet. Change any number and the
   discount is removed and the panel reverts to individual pricing.

   Adding to basket reads each component's variant id straight from its parure
   row, so the colour / size the customer chose above is what gets added. */
(function () {
  var root = document.querySelector('[data-set-builder]');
  if (!root) return;

  var items = [].slice.call(root.querySelectorAll('[data-set-item]'));
  if (!items.length) return;

  var discount = parseFloat(root.dataset.discount) || 0;
  var moneyFormat = root.dataset.moneyFormat || '{{amount}}';

  /* Translated sentences come from the template (see the data-t-* attributes in
     tessera-set-builder.liquid): this file is a plain asset, so it cannot use
     Liquid's `t` filter. "%s" marks where a value is substituted. */
  var T = root.dataset;
  function fill(str, value) { return (str || '').replace('%s', value); }

  var elSave = root.querySelector('[data-set-save]');
  var elSaveLine = root.querySelector('[data-set-save-line]');
  var elTotal = root.querySelector('[data-set-total]');
  var elTotalLabel = root.querySelector('[data-set-total-label]');
  var elBadge = root.querySelector('[data-set-badge]');
  var elStatus = root.querySelector('[data-set-status]');
  var elStatusText = root.querySelector('[data-set-status-text]');
  var elAdd = root.querySelector('[data-set-add]');
  var elAddText = root.querySelector('[data-set-add-text]');
  var elWas = root.querySelector('[data-set-was]');
  var elToggle = root.querySelector('[data-set-toggle]');
  var elDetails = root.querySelector('[data-set-details]');

  /* Strip thumbnails carry the live quantity, keyed to the same product id as
     the row in the details panel, so stepping a quantity updates both. */
  var thumbs = {};
  [].slice.call(root.querySelectorAll('[data-set-thumb]')).forEach(function (t) {
    thumbs[t.dataset.productId] = t;
  });

  /* ---------- money ---------- */
  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function withCommas(intStr) {
    return intStr.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
  }

  function formatMoney(cents, format) {
    var value = (cents || 0) / 100;
    var fmt = format || '{{amount}}';
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, name) {
      var whole = Math.floor(Math.abs(value));
      var frac = Math.round((Math.abs(value) - whole) * 100);
      if (frac === 100) { whole += 1; frac = 0; }
      switch (name) {
        case 'amount_no_decimals':
          return withCommas(String(whole));
        case 'amount_with_comma_separator':
          return withCommas(String(whole)).replace(/,/g, '.') + ',' + pad(frac);
        case 'amount_no_decimals_with_comma_separator':
          return withCommas(String(whole)).replace(/,/g, '.');
        default: // amount
          return withCommas(String(whole)) + '.' + pad(frac);
      }
    });
  }

  /* ---------- state ---------- */
  function readQty(item) {
    var input = item.querySelector('[data-set-qty]');
    var n = parseInt(input.value, 10);
    if (isNaN(n) || n < 0) n = 0;
    return n;
  }

  function recalc() {
    var fullTotal = 0;
    var eligible = true;
    var mismatches = [];

    items.forEach(function (item) {
      var need = parseInt(item.dataset.need, 10) || 0;
      var unit = parseInt(item.dataset.unit, 10) || 0;
      var qty = readQty(item);
      var line = unit * qty;
      fullTotal += line;

      var lineEl = item.querySelector('[data-set-line]');
      if (lineEl) lineEl.textContent = formatMoney(line, moneyFormat);

      var flag = item.querySelector('[data-set-flag]');
      var off = qty !== need;
      if (off) {
        eligible = false;
        var name = item.querySelector('.tessera-set__item-name');
        mismatches.push((name ? name.textContent.trim() : '') + ' ' + fill(T.tNeedsShort, need));
      }
      item.classList.toggle('is-off-set', off);
      if (flag) flag.hidden = !off;

      var thumb = thumbs[item.dataset.productId];
      if (thumb) {
        var badge = thumb.querySelector('[data-set-thumb-qty]');
        if (badge) badge.textContent = qty;
        /* A component dropped to zero is still shown, greyed, so the strip
           keeps its shape and the customer can see what they removed. */
        thumb.classList.toggle('is-empty', qty === 0);
        thumb.classList.toggle('is-off-set', off);
      }
    });

    var save = eligible ? Math.round((fullTotal * discount) / 100) : 0;
    var total = fullTotal - save;

    if (elSave) elSave.textContent = '−' + formatMoney(save, moneyFormat);
    if (elTotal) elTotal.textContent = formatMoney(total, moneyFormat);
    if (elSaveLine) elSaveLine.hidden = !eligible;
    if (elTotalLabel) elTotalLabel.textContent = eligible ? T.tSetPrice : T.tTotal;
    /* Off-composition there is no discount, so the struck-through "was" price
       would repeat the price next to it. Hide it rather than show it twice. */
    if (elWas) {
      elWas.hidden = !eligible;
      elWas.textContent = formatMoney(fullTotal, moneyFormat);
    }

    root.classList.toggle('is-eligible', eligible);
    if (elBadge) elBadge.hidden = !eligible;

    if (elStatus) elStatus.setAttribute('data-state', eligible ? 'on' : 'off');
    if (elStatusText) {
      var list = mismatches.slice(0, 2).join(', ');
      if (mismatches.length > 2) list += ' ' + fill(T.tAndMore, mismatches.length - 2);
      elStatusText.textContent = eligible ? T.tOn : fill(T.tOff, list);
    }
    /* Kept short: in the 2a strip this button sits in a fixed-width column,
       and the saving is already stated in the heading beside it. */
    if (elAddText) {
      elAddText.textContent = eligible ? T.tAdd : T.tAddPartial;
    }

    return { eligible: eligible, total: total };
  }

  /* ---------- quantity controls ---------- */
  items.forEach(function (item) {
    var input = item.querySelector('[data-set-qty]');
    item.querySelectorAll('[data-set-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var delta = parseInt(btn.dataset.setStep, 10) || 0;
        var next = readQty(item) + delta;
        if (next < 0) next = 0;
        input.value = next;
        recalc();
      });
    });
    input.addEventListener('input', recalc);
    input.addEventListener('change', recalc);
  });

  /* ---------- "Adjust contents & quantities" disclosure ---------- */
  /* The panel is plain [hidden] on load so it costs nothing before the script
     runs and stays reachable if the script never does. */
  if (elToggle && elDetails) {
    elToggle.addEventListener('click', function () {
      var open = elToggle.getAttribute('aria-expanded') === 'true';
      elToggle.setAttribute('aria-expanded', open ? 'false' : 'true');
      elDetails.hidden = open;
      root.classList.toggle('is-open', !open);
      if (!open) {
        var firstQty = elDetails.querySelector('[data-set-qty]');
        if (firstQty) firstQty.focus();
      }
    });
  }

  /* ---------- add the set ---------- */
  /* Pull the live variant id from the component's own parure row so the
     customer's colour / size selection is respected. */
  function variantIdFor(productId) {
    var row = document.querySelector('[data-parure-row][data-product-id="' + productId + '"]');
    if (!row) return null;
    var input = row.querySelector('[name="id"]');
    if (!input || !input.value) return null;
    return input.value;
  }

  if (elAdd) {
    elAdd.addEventListener('click', function () {
      var payload = [];
      var unavailable = [];

      items.forEach(function (item) {
        var qty = readQty(item);
        if (qty <= 0) return;
        var vid = variantIdFor(item.dataset.productId);
        if (!vid) {
          var nm = item.querySelector('.tessera-set__item-name');
          unavailable.push(nm ? nm.textContent.trim() : '');
          return;
        }
        payload.push({ id: vid, quantity: qty });
      });

      if (!payload.length) {
        if (elStatusText) elStatusText.textContent = T.tChooseOne;
        return;
      }

      elAdd.setAttribute('disabled', 'disabled');
      elAdd.classList.add('is-loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: payload })
      })
        .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.body && res.body.description) || T.tAddFailed);
          if (unavailable.length && elStatusText) {
            elStatusText.textContent = fill(T.tNeedsSelection, unavailable.join(', '));
          }
          window.location.href = '/cart';
        })
        .catch(function (err) {
          elAdd.removeAttribute('disabled');
          elAdd.classList.remove('is-loading');
          if (elStatusText) elStatusText.textContent = err.message || T.tError;
        });
    });
  }

  recalc();
})();
